// hooks/useFormViewerWizard/buildSplitPatch.ts — Kolom split 3 utk PATCH wizard.
// AI tab = Detail + RT/RW/No + Patokan SAJA (desa+ hilang). shippingAddress
// tetap gabungan 3 (kompat Everpro/WA/label, min 30 char).
export function buildSplitPatch(addressData: any): {
    address_detail?: string; address_rtrw?: string; address_landmark?: string;
    ai_formatted_address?: string; shippingText: string;
} {
    const sad = (addressData || {}) as any;
    const sD = String(sad?.address_detail || '').trim();
    const sR = String(sad?.address_rtrw || '').trim();
    const sL = String(sad?.address_landmark || '').trim();
    return {
        address_detail: sD || undefined, address_rtrw: sR || undefined,
        address_landmark: sL || undefined,
        ai_formatted_address: [sD, sR, sL].filter(Boolean).join(', ') || undefined,
        shippingText: [sD, sR, sL].filter(Boolean).join(', '),
    };
}
